import { toast } from "@picklebet/ui";
import type { Nullable } from "types/utilities";
import type { CustomerLicence } from "@/features/auth/stores/authStore";
import { telemetry } from "@/utilities/telemetry";
import type {
  UserVerificationDataSourceAttemptStatus,
  VerificationDataSource,
} from "../types/Verification";

export const handleFailedVerificationAttempt = (
  type: VerificationDataSource,
  licence: Nullable<CustomerLicence>,
) => {
  telemetry.submittedVerificationForm({
    outcome: "failure",
    type,
    licence: licence ?? undefined,
  });

  toast({
    title: "Unable to submit verification data",
    variant: "danger",
    description:
      "Something went wrong. Please contact support if the error persists",
  });
};

/** Maps user verification data sources to their respective route path */
export const verificationDataSourcePathMap: Record<
  VerificationDataSource,
  string
> = {
  AustralianDriversLicence: "australian-drivers-licence",
  AustralianPassport: "australian-passport",
  MedicareCard: "medicare",
  AustralianVisaCheck: "australian-visa",
  NewZealandDriversLicence: "nz-drivers-license",
  NewZealandPassport: "nz-passport",
  NationalId: "national-identification-system",
} as const;

/*
 * Maps user verification statuses to a format that is more readable for a user
 */
export const verificationStatusLabelMap: Record<
  UserVerificationDataSourceAttemptStatus,
  string
> = {
  UNVERIFIED: "Verify",
  IN_PROGRESS: "In progress",
  FAILED: "Unsuccessful",
  ERROR_OCCURRED: "Unsuccessful",
  REJECTED_FOR_RESUBMIT: "Unsuccessful",
  VERIFIED: "Verified",
  VERIFIED_ADMIN: "Verified",
  PENDING_REVIEW: "In review",
  PENDING_MANUAL_REVIEW: "In review",
} as const;
